import { render } from "./MenuDashboard.vue?vue&type=template&id=1a9d5018&scoped=true"
import script from "./MenuDashboard.vue?vue&type=script&lang=js"
export * from "./MenuDashboard.vue?vue&type=script&lang=js"

import "./MenuDashboard.vue?vue&type=style&index=0&id=1a9d5018&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9d5018"]])

export default __exports__